<template>
  <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
    <div>
      <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
        {{ header }}
      </h1>
      <h2 class="text-grey-dark text-sm font-medium leading-normal">
        {{ subheader }}
      </h2>
    </div>
    <div class="mt-4 md:mt-0" :class="fullWidth ? 'w-full' : 'ml-auto'">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    header: String,
    subheader: String,
    fullWidth: Boolean
  }
}
</script>
